import { render, staticRenderFns } from "./divvySetting.vue?vue&type=template&id=7a915a9a&scoped=true&"
import script from "./divvySetting.vue?vue&type=script&lang=js&"
export * from "./divvySetting.vue?vue&type=script&lang=js&"
import style0 from "./divvySetting.vue?vue&type=style&index=0&id=7a915a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a915a9a",
  null
  
)

export default component.exports